import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { showAlertModal } from './../../../../redux/helpers/';


import PageBackgroundColor from './page-background-color/PageBackgroundColor';


class Colors extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      opened: true,

      backgroundColorOpened: true,
    };
    this.clicked = false;
  }

  componentDidUpdate() {
    const {
      isSavedBook,
    } = this.props;

    const { backgroundColorOpened, opened } = this.state;
    const ifConsumerAndNewBook = backgroundColorOpened && isSavedBook && !this.clicked;
    if (ifConsumerAndNewBook) {
      this.setState({
        backgroundColorOpened: !backgroundColorOpened,
        opened: !opened,
      });
    }
  }

  changeDropDown = () => {
    const { opened } = this.state;
    const {
      backgroundType, lang, selectedBackgroundColor, backgroundImage, context,
    } = this.props;

    if ((backgroundType === '' && (selectedBackgroundColor === '' || backgroundImage === '') && context !== 'pro') || (backgroundType === 'tematikus' && backgroundImage === '')) {
      return showAlertModal(lang.title_notice, lang.select_background);
    }
    return this.setState({
      opened: !opened,
      backgroundColorOpened: false,

    });
  }


  changeBackgroundColorDropDown = () => {
    this.clicked = true;
    const { backgroundColorOpened } = this.state;
    this.setState({

      backgroundColorOpened: !backgroundColorOpened,
      opened: true,
    });
  }


  render() {
    const {
      opened,
      backgroundColorOpened,
    } = this.state;

    const {
      pageId,
      pageOrder,
      lang,
      pages,
    } = this.props;


    const backgroundShow = backgroundColorOpened ? 'show' : '';

    return (
      <div className="colorWrapper">
        <div className={`marginWrapper ${backgroundShow}`}>
          <button ref={(backgroundButton) => { this.backgroundButton = backgroundButton; }} type="button" className="btn green-btn margin-btn" onClick={this.changeBackgroundColorDropDown.bind(this)}>
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="12" viewBox="0 0 24 12">
              <path d="M13,0V12H24V0ZM0,12H11V0H0Z" />
            </svg>
            {lang.background_color}
          </button>
          <div className={`dropdown-menu background-picker circle-picker ${backgroundShow}`}>
            <PageBackgroundColor
              pageId={pageId}
              pageOrder={pageOrder}
              lang={lang}
              pages={pages}
            />
          </div>
        </div>
        { opened ? <div onClick={this.changeDropDown.bind(this)} className="overlay" /> : ''}
      </div>
    );
  }
}

Colors.defaultProps = {
  pageId: 0,
  pageOrder: 0,
  lang: {},
  context: '',
  backgroundType: '',
  selectedBackgroundColor: '',
  backgroundImage: '',
  isSavedBook: false,
};

Colors.propTypes = {
  pageId: PropTypes.number,
  pageOrder: PropTypes.number,
  lang: PropTypes.object,
  context: PropTypes.string,
  backgroundType: PropTypes.string,
  selectedBackgroundColor: PropTypes.string,
  backgroundImage: PropTypes.string,
  isSavedBook: PropTypes.bool,
};

export default connect(state => ({
  spine: state.entities.cover.spine,
  context: state.bookProperties.context,
  backgroundType: state.editorUI.bookProperties.backgroundType,
  selectedBackgroundColor: state.editorUI.bookProperties.backgroundColor,
  backgroundImage: state.editorUI.bookProperties.backgroundImage,
  isSavedBook: state.editorUI.isSavedBook,
}))(Colors);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/colors/Colors.jsx